import { Editor } from "grapesjs";

export const iconsMapp = (editor: Editor) => {
  for (let [key, value] of Object.entries(editor.Blocks.getAllMap())) {
    if (blocksIconsMapping[key]) {
      value.attributes.media = `<i class="${blocksIconsMapping[key]} fs-2"></i>`;
    }
  }

  const customOrder = [
    "column1",
    "column2",
    "column3",
    "column3-7",
    "box",
    "hero-block",

    "heading-block",
    "text",
    "icon",

    "link",
    "link-block",

    "image",
    "video",
    "keen-slider",

    "leaflet-map",
    "leaflet-marker",

    "jobs-feed-block",
    "jobs-feed-more",
    "gobi-story-block",
    "application-fomr",

    "custom-code",
    "navbar",
  ];
  const blocks = editor.BlockManager.getAll().models;
  blocks.sort((a, b) => {
    const aIndex = customOrder.indexOf(a.id.toString());
    const bIndex = customOrder.indexOf(b.id.toString());
    return aIndex - bIndex;
  });



  editor.BlockManager.render();
};

const blocksIconsMapping: Record<string, string> = {
  column1: "fa-kit fa-cs-col-1",
  column2: "fa-kit fa-cs-col-2",
  column3: "fa-kit fa-cs-col-3",
  "column3-7": "fa-kit fa-cs-col-2b",
  image: "fa-sharp fa-light fa-image",
  link: "fa-sharp fa-light fa-link",
  map: "fa-sharp fa-light fa-map",
  text: "fa-sharp fa-light fa-text",
  video: "fa-sharp fa-light fa-film",
};
